import { render, staticRenderFns } from "./SettingsCustomers.vue?vue&type=template&id=415afd58&"
import script from "./SettingsCustomers.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports